<ng-container *ngIf="(selectedOrganization$ | async) as selectedOrganization">
  <!-- Floor should be selected to activate -->
  <ng-container *ngIf="(selectedFloorId$ | async) as selectedFloorId; else noSelectedFloor"
                [ngSwitch]="(uploadedFloorImageWithSource$ | async)?.source || (selectedFloorPlanImageUrl$ | async)">
    <awair-floor-plan-image-empty *ngSwitchCase="null"
                                  [selectedFloorId]="selectedFloorId"
                                  (fileUpload)="onFileUpload($event, false)">
    </awair-floor-plan-image-empty>
    <ng-container *ngSwitchDefault>
      <!-- Map + Marker -->
      <!-- When adding mapUrl, uploaded image should be more prioritized than the saved one -->
      <ng-container *ngIf="(deviceEntities$ | async) as deviceEntities">
        <ng-container *ngIf="(deviceMarkerEntities$ | async) as deviceMarkerEntities">
          <awair-floor-plan-editor-map class="__map-group"
                                       [mapUrl]="(uploadedFloorImageWithSource$ | async)?.source || (selectedFloorPlanImageUrl$ | async)"
                                       [addedDeviceMarkers]="addedDeviceMarkers$ | async"
                                       [updatedDeviceMarker]="updatedDeviceMarker$ | async"
                                       [removedDeviceMarkerUuids]="removedDeviceMarkerUuids$ | async"
                                       (dropDevice)="onDropDevice($event, deviceEntities, deviceMarkerEntities, selectedFloorId)"
                                       (removeMarker)="onRemoveMarker($event)">
          </awair-floor-plan-editor-map>
        </ng-container>
      </ng-container>

      <awair-image-uploader [hasDeviceMarkers]="hasDeviceMarkers"
                            (fileUpload)="onFileUpload($event, hasDeviceMarkers)">
        <!-- Making button element inside image uploader won't work -->
        <div class="__reupload-button">
          <awair-map-icon [color]="'#64C2E6'"></awair-map-icon>
          Reupload
        </div>
      </awair-image-uploader>
    </ng-container>

    <div class="__save-toast" [style.opacity]="showToast ? 1 : 0">
      {{saveToastMsg}}
    </div>
    <!-- /.Map + Marker -->
  </ng-container>
  <ng-template #noSelectedFloor>
    <ng-container [ngSwitch]="(hasFloor$ | async)">
      <div class="__no-selected" *ngSwitchCase="false">
        <h1 class="__no-selected-header">Create a New Floor</h1>
        <p class="__no-selected-desc">
          Get started by creating a floor plan view of your first floor.
        </p>
      </div>
      <div class="__no-selected" *ngSwitchDefault>
        <p class="__no-selected-desc">
          You can edit existing floors and add additional floors by selecting from the Floor List on the left.
        </p>
      </div>
    </ng-container>
  </ng-template>
</ng-container>
